import { render, staticRenderFns } from "./VendingMachineCard.vue?vue&type=template&id=c6349a48"
import script from "./VendingMachineCard.vue?vue&type=script&lang=js"
export * from "./VendingMachineCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports